export default __webpack_public_path__ + "static/media/AD-DAP_Data_Use_Agreement_2022.1cf8104d.pdf";